export const POPULAR_CATEGORY = 'popular'
export const CRYPTO_CATEGORY = 'crypto'
export const CASH_REDEMPTION_IDS = ['paypal', 'venmo']
